import * as React from 'react';
import { AppDesignScheme, Currency } from '../../Api';
import { ToCurrency } from '../../BasketControl';
import * as Store from '../../Store';
const tinycolor = require('tinycolor2');

interface Props {
  Price: number;
  Currency: Currency;
  AppDesignScheme: AppDesignScheme;
  Extra?: string;
  className?: string;
  Languages?: Store.Language[];
  isDark: boolean;
}

interface State {}

export class Price extends React.Component<Props, State> {
  public render(): JSX.Element {
    const { Languages, AppDesignScheme, isDark } = this.props;
    let initialLang = 'en';

    if (Languages) {
      for (const Language of Languages) {
        if (Language.active) {
          initialLang = Language.code;
          break;
        }
      }
    }

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      price: {
        borderColor: tinycolor(AppDesignScheme.Primary)
          .darken(20)
          .toString()
      }
    };

    return (
      <span
        className={`text-center checkout__items__item-price flex flex-align-center flex-justify-center ${this.props.className}`}
        style={styles.price}
      >
        <p
          data-fd="voucher-price"
          tabIndex={0}
          className="inline-block secondary clear-margins bold fd-h4"
          style={isDark ? styles.primary : styles.secondary}
        >
          {this.props.Extra}
          {ToCurrency(this.props.Price, this.props.Currency, initialLang)}
        </p>
      </span>
    );
  }
}

export default Price;
